import deferralConstants from "./deferralConstants";
import call from "@brainspore/celadon-base/service/http";
import examConstants from "@/packages/exams/examConstants";
import { helper } from "@/packages/dashboard/utils";
import ExemptionConstants from "@/packages/exemptions/ExemptionConstants";
// import { helper } from "@/packages/dashboard/utils";

export default {
  namespaced: true,
  state: {
    deferrals: [],
    deferral: {},
    programmeRegistration: [],
    attachmentDialog: false,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    deferralGetter: (state) => (val) => state[val],
  },
  actions: {
    setAttachmentDialog({ commit }, payload) {
      commit("MUTATE", { state: "attachmentDialog", data: payload });
    },
    // GET student's current programme
    studentProgramme: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.PROGRAMME_REGISTRATION)
        .then((res) => {
          commit("MUTATE", {
            state: "programmeRegistration",
            data: res.data.data.filter((el) => el.current /**&& el.invoiced*/),
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },

    // GET Deferrals
    getExamDeferrals: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", deferralConstants.EXAM_DEFERRAL, payload)
        .then((res) => {
          commit("MUTATE", {
            state: "deferrals",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // GET Deferral
    getExamDeferral: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      let decryptedCode = helper.decrypt(payload);
      call("get", deferralConstants.SHOW_EXAM_DEFERRAL(decryptedCode))
        .then((res) => {
          commit("MUTATE", {
            state: "deferral",
            data: res.data.data.shift(),
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // POST Deferrals
    examDeferral: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", deferralConstants.EXAM_DEFERRAL, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("back");
          dispatch("getExamDeferrals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // patch deferrals
    patchDeferral: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", deferralConstants.PATCH_EXAM_DEFERRAl, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Updated Deferral Entry");
          Event.$emit("back");
          dispatch("getExamDeferrals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // delete deferrals
    deleteDeferral: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", deferralConstants.DELETE_EXAM_DEFERRAL, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted deferral entry");
          dispatch("getExamDeferrals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteAttachment({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.deleteAttachment, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted Attachment");
          dispatch("getExamDeferral", helper.encrypt(payload.documentNo));
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
